import DashboardCard from "../../../ui/DashboardCard/DashboardCard.tsx";
import type { AdultDashboardUpcomingGigItemResponse } from "../../../../types/adultDashboardTypes.ts";
import { toCurrency, toReadableGigDateTime } from "../shared/dashboardDisplay";

type AdultUpcomingScheduledGigsBoxProps = {
  upcomingScheduledGigs: AdultDashboardUpcomingGigItemResponse[];
  loading: boolean;
};

const AdultUpcomingScheduledGigsBox = ({ upcomingScheduledGigs, loading }: AdultUpcomingScheduledGigsBoxProps) => {
  return (
    <DashboardCard
      title="Scheduled Gigs Awaiting Completion"
      subtitle="Accepted gigs waiting on completion."
      to="/adult/scheduled-gigs"
    >
      {loading ? (
        <p className="text-sm text-myteengig-text-muted">Loading upcoming gigs...</p>
      ) : upcomingScheduledGigs.length === 0 ? (
        <p className="text-sm text-myteengig-text-muted">No upcoming scheduled gigs.</p>
      ) : (
        <ul className="space-y-2 sm:space-y-3">
          {upcomingScheduledGigs.map((gig) => (
            <li key={gig.requestId} className="rounded-lg border border-myteengig-border bg-myteengig-background p-2.5 sm:p-3">
              <div className="flex items-start justify-between gap-2">
                <p className="min-w-0 text-sm font-semibold leading-5 text-myteengig-text-primary sm:text-base">{gig.gigTitle ?? "Untitled Gig"}</p>
                <p className="shrink-0 text-sm font-semibold leading-5 text-myteengig-primary">{toCurrency(gig.paymentAmountCents, gig.volunteer)}</p>
              </div>
              <p className="mt-1 text-xs leading-5 text-myteengig-text-muted sm:text-sm">
                {[gig.teenFirstName, gig.teenLastName].filter(Boolean).join(" ") || "Teen"} · {toReadableGigDateTime(gig.confirmedStartTime, gig.gigTimeZone)}
              </p>
            </li>
          ))}
        </ul>
      )}
    </DashboardCard>
  );
};

export default AdultUpcomingScheduledGigsBox;
